import {useMemo, useEffect, useState} from 'react';
import { Button, Container} from "semantic-ui-react";
import { Link } from "react-router";
import MainTiles from "../../xAppLib/UIelems/MainTiles";
import FAQ from "../../xAppLib/UIelems/FAQ";
import { cls } from 'views/NUI/utils';
import { useOnePassDiscountStrings } from "../../xAppLib/Hooks/discounts/useOnePassDiscountStrings";
import { PUBLIC_DISCOUNT_KEYS } from "@iscr/constants";
import { SEOHeaders } from "components/SEOHeaders";

const op_img_path = "https://storage.googleapis.com/instant-med-public/OnePass";

const pricing_terms = <>
                        *Exclusions, T&Cs apply. Express click & collect already available to all customers at Officeworks & Target.<br/>
                        †Savings compared to separately purchasing OnePass monthly memberships.<br/>
                    </>

const Hero = ({usr}) => {
    const onepassDiscountStrings = useOnePassDiscountStrings();
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {setScrollY(window.scrollY)};
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const header_imgs = <>
        <img src={`${op_img_path}/Increase_and_Decrease-purple.svg`} alt="Onepass Purple Heart" className="h-[120px] w-[120px] md:h-[148px] md:w-[148px] rotate-(11.263deg) absolute -top-2 md:top-6 right-4 md:right-[32px] md:right-[70px]"/>
        <img src={`${op_img_path}/onesie-hero.png`} className={cls("absolute w-[308px] md:w-[499px] right-0 left-0 md:right-[53px] mx-auto top-[56px] md:top-[45px] h-auto")} alt="onesie"/>
        <img style={{ transform: `translateY(${scrollY * -0.1}px)` }} src={`${op_img_path}/heart-layer-1.png`} className={cls("absolute top-1/2 left-[30px] md:left-[55px] h-[22px]")} alt="heart"/>
        <img style={{ transform: `translateY(${scrollY * -0.2}px) rotate(-30deg)` }} src={`${op_img_path}/heart-layer-2.png`} className={cls("absolute -top-6 md:-top-12 left-8 md:left-[70px] md:right-[70px] h-[140px] md:h-[175px]")} alt="heart"/>
        <img style={{ transform: `translateY(${scrollY * -0.15}px)` }} src={`${op_img_path}/heart-layer-3.png`} className={cls("absolute bottom-[80px] md:bottom-6 right-6 md:right-[70px] h-[33px] md:h-[54px]")} alt="heart"/>
    </>

      return  <div className={cls("h-auto relative flex flex-wrap", usr ? "bg-is-blue md:h-[417px]" : "bg-white")}>
                    {usr && <>  
                                <img src={`${op_img_path}/woman_using_app_sm.jpg`} className={cls("w-full block md:hidden", 'order-1')} alt="woman using IS app"/>
                                <div className={cls("absolute top-0 bottom-0 left-1/2 right-0 bg-cover bg-no-repeat md:block hidden rounded-bl-[270px]", usr ? "md:left-[50%] xl:left-[60%]" : "bg-center md:left-[50%]" )} style={{backgroundImage: `url(${op_img_path}/woman_using_IS_app.jpg)`}}></div>
                            </>
                    }
                    <Container className={cls(usr ? "order-2 md:order-1" : "relative order-1 py-[52px] md:pt-[96px] md:pb-8")}>
                        {usr ? 
                            <>
                                <div className={cls("pt-12 md:pt-0 flex flex-wrap w-full md:w-1/2 items-center justify-center md:justify-start gap-2", usr && "md:mt-[100px] lg:mt-[152px]")}>
                                    <img src={`${op_img_path}/Is_logo_white_wide.svg`} alt="InstantScripts"/>
                                    <div className="border-r-[0.5px] border-white opacity-50 h-[53px] mx-4 hidden lg:block"></div>
                                    <img src={`${op_img_path}/onepass_purple_bg.svg`} className="px-8 sm:px-0" alt="OnePass"/>
                                </div>
                                <h2 className="!text-white mt-4 text-center md:text-left pb-11 md:pb-0 w-full !text-is2_xl">Start enjoying your<br className="block xl:hidden"/> OnePass benefits</h2>
                            </>
                        :  
                            <>
                                  
                                <div className="flex flex-col md:flex-row justify-between mb-[52px] md:min-h-[470px]">
                                    <div className="lg:w-1/2 order-2 md:order-1">
                                        <img src={`${op_img_path}/onepass_icon_purple.svg`} className="h-9 md:h-[44px] mb-8 md:mb-[52px]" alt="OnePass"/>
                                        <h1 className="text-is-black font-bold !text-xl md:!text-is2_5xl !mb-9 md:!mb-4 !mt-0">Enjoy more value<br/> & benefits</h1>
                                        <div className="relative md:hidden min-h-[349px] max-w-[308px] mx-auto">
                                            {header_imgs}
                                        </div>
                                 
                                        <div className="bg-white md:bg-none rounded-md md:rounded-none py-6 md:p-0 md:mb-4 md:mb-0">
                                            {onepassDiscountStrings && onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS] && onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST] && <p className="text-is-black-50 mb-6">
                                            {onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST]} off your first eligible InstantScripts service and {onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS]} off each eligible service thereafter on eligible InstantScripts services*.</p>} 
                                            <Button className="!text-[1.3rem] !md:text-[1.5rem] !py-4 !px-[21px] md:!px-[32px] w-full md:w-fit" primary as="a" href="https://my.onepass.com.au/auth/signup?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_signup" style={{background: '#9900F1'}}>Start your 30 day free trial</Button>
                                        </div>
                                        <p className="text-base font-medium text-is-black-50 mt-0 md:mt-6">Already a member? <a className="text-is-blue cursor-pointer decoration-transparent hover:decoration-is-blue hover:underline" href="https://my.onepass.com.au/auth/login?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_login" onClick={() => app.trigger(app.events['REQUEST_LOGIN'])}>Log in with OnePass</a></p>
                                            
                                    </div>
                                    <div className="relative w-full lg:w-1/2 order-1 md:order-2 hidden md:block">
                                        {header_imgs}
                                    </div>
                                </div>
                            </>
                        }
                        {!usr && <div className="flex flex-col relative md:z-2">
                            <p className="text-sm text-is-black-50 order-2 md:order-1 mb-4 md:mb-0">By activating OnePass you agree that InstantScripts and OnePass will confirm you have an account with the other to enable your accounts to be linked and you to receive your benefits and communications. Your personal information will be handled in accordance with the InstantScripts Privacy Policy.</p>
                            <p className="text-base font-medium mt-2 mb-1 order-3 md:order-2">Try it for free, cancel anytime.</p>
                            <p className="text-[12px] text-is-black-50 leading-[18px] order-4 md:order-3 mt-0 mb-4 md:mb-2">After your free trial, OnePass is only $4/month or $40/year.</p>
                            <p className="text-[12px] text-is-gray-25 leading-[18px] order-1 md:order-4 !mb-4 md:!mb-0">
                                <sup>1</sup>Limited to Online Prescription, Telehealth Consultations, Medical Certificates, Blood Test Requests and Specialist Referrals.<br/><br className="md:hidden"/>
                                *T&Cs, Exclusions and eligibility criteria apply. <a href="#terms">Click here to view</a>.
                            </p>
                        </div>}
                    </Container>
                </div>
};

const Intro = ({usr, onepassDiscountStrings}) => {

    const boxes = useMemo(() => {
        
        if (!onepassDiscountStrings) return [];
        return [
            {
            icon: 'increase_decrease',
            title: `${onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS]} off eligible InstantScripts services*`,
            desc:  (onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST] ? `${onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST]} off your first eligible InstantScripts service and ` : '') + `${onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS]} off each eligible service thereafter on eligible InstantScripts services including Online Prescription Consultations, Medical Certificates, Doctor Consultations, Blood Test Requests, Specialist Referrals`
            },
            {
            icon: 'delivery_pill_icon',
            title: 'Free standard delivery on prescription medication in Australia*',
            desc: 'Free standard delivery on prescription medication in Australia prescribed by an InstantScripts doctor'
            },
        ]}, [onepassDiscountStrings])
    return <div className={cls("py-10 md:pt-20 md:pb-[32px] bg-is-gray-20")}>
        <Container>
            <h2 className={cls("!text-is-black-80 text-center flex items-center justify-center mx-auto mb-9 md:mb-[52px]", !usr && "font-bold md:font-normal")}>{usr ? <>Your InstantScripts +<br className="block md:hidden"/> OnePass benefits</> : <>What OnePass members get at InstantScripts</>}</h2>
            
            {!usr && <div className="bg-op-purple py-8 px-[18px] md:p-8 flex flex-col md:flex-row justify-between rounded-xl mb-4 md:h-[212px] gap-6">
                <div className="text-white flex flex-col justify-center order-2 md:order-1">
                    {onepassDiscountStrings && onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST] && <h3 className="!text-white font-bold text-is2_lg md:!text-lg">Enjoy {onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST]} off your first eligible InstantScripts service<sup className="text-xs">1</sup></h3>}
                    <p>Exclusive OnePass member offer for first-time InstantScript users.</p>
                </div>
                <img src={`${op_img_path}/Increase_and_Decrease.svg`} className="h-[148px] w-[148px] order-1 md:order-2" alt="Discount icon"/>
            </div>}
            
            <div className="grid md:grid-cols-2 gap-4">
                {boxes.map((el, i) => {
                    return <div key={i} className="flex flex-col items-start bg-white rounded-xl border border-is2-gray-100 px-4 md:px-8 py-6 text-left">
                        <div>
                            <img src={`${op_img_path}/${el.icon}.svg`} alt={el.icon} />
                            <h3 className="font-bold text-left md:min-h-[64px] mt-2 text-is2_lg md:!text-lg">{el.title}</h3>
                        </div>
                        <p className="text-is-black-50 mt-4 text-left">{el.desc}</p>
                    </div>
                })}
            </div>

            <div className="pt-6 md:pt-[52px] w-full mx-auto">
                {usr ?
                    <p className="text-sm text-is-gray-25 text-center">*Terms and conditions, exclusions and eligibility criteria apply.<br/>
                      To view our full OnePass Terms and Conditions <a href="#terms" className="text-is-blue underline">click here</a>.
                    </p>
                : <p className="text-sm text-is-gray-25 text-left">*T&Cs, Exclusions apply and eligibility criteria apply. <a href="#terms">Click here to view.</a> Standard delivery only, express delivery not eligible for free delivery.</p>}
            </div>
        </Container>
    </div>
}

const Benefits = () => {

    return (
        <div className="bg-is-blue">
            <MainTiles
                show_pr={true}
                excl={["/c/pharm/subscr"]}
                colour="white"
                title={
                    <h2 className="!text-white text-center mb-12">
                        Start enjoying the benefits*
                    </h2>
                }
                size="md"
            />
            <p className="text-white text-center mt-0 pb-[96px]">
                *Prices listed above may vary and are subject to change.
            </p>
        </div>
    );
}

const Other = ({usr}) => {
    const other_boxes = [
        {
            title: 'Free Delivery on eligible items or orders',
            icon: 'free_delivery'
        },
        {
            title: '5x Flybuys points in-store',
            icon: 'flybuys'
        },
        {
            title: '365 day change of mind returns',
            icon: '365_day_returns'
        },
        {
            title: 'Express Click & Collect',
            icon: 'express_click_collect'
        },
        {
            title: 'Member Exclusives',
            icon: 'exclusive'
        },
    ]

    const brands = ['Kmart', 'Target-red', 'Bunnings', 'Officeworks', 'priceline-pharmacy']
    const partners = ['Flybuys']

    return <div className={cls("py-10 md:pt-20 md:pb-8 text-center bg-is-gray-20", !usr && "bg-white")}>
        <Container>
            <h2 className="!text-lg md:!text-is2_4xl mb-0">{usr ? 'Unlock more benefits from other OnePass brands' : 'Get more value from your favourite brands.'} </h2>

            <div className="flex flex-wrap items-center justify-center gap-4 py-8">
                <div className="flex flex-wrap md:flex-nowrap justify-between md:justify-center gap-2 w-full md:w-fit">
                    {brands.map((el, i) => { return <img src={`${op_img_path}/${el}.svg`} className="h-5 md:h-8 md:mx-2.5" key={i} alt={el.replace('-', ' ')}/>})}
                </div>
                <div className="border-r-[0.5px] border-black opacity-50 h-9 mx-2 hidden md:block"></div>
                <div className="flex flex-wrap md:flex-nowrap items-center justify-center border-t-[.5px] border-op-purple md:border-none pt-4 md:pt-0 w-full md:w-auto">    
                    <h5 className="text-op-purple text-sm mb-0 mx-2.5">OnePass<br className="hidden md:block"/> Partners</h5> 
                    {partners.map((el, i) => {return <img src={`${op_img_path}/${el}.svg`} className="h-6 md:h-9 mx-2.5" key={i} alt={el}/>})}
                </div>
            </div>

            <div className="w-full grid grid-cols-2 md:grid-cols-5 gap-2 md:gap-3 mx-auto">
                {other_boxes.map((el, i) => {
                    return <div className="grid-col-2 bg-white rounded-md shadow p-4 flex flex-col items-start self-stretch text-left gap-1" key={i}>
                        <img src={`${op_img_path}/${el.icon}.png`} className="h-12" alt={el.title}/>
                        <p>{el.title}</p>
                    </div>
                })}
            </div>
            <p className="py-6 md:py-[52px] mb-0 font-normal"><a href="https://onepass.com.au/partners?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_partners" target="_blank" className="text-op-purple !underline-none">Learn more</a> on what you get at OnePass brands</p>
            {usr ? <p className="text-sm text-is-gray-25">*<a href="#terms">T&Cs</a>, Exclusions apply. Express click & collect already available to all customers at Officeworks & Target.</p>
            : <p className="text-left md:text-center text-sm text-is-gray-25"><a href="#terms">T&Cs</a>, Exclusions and eligibility criteria apply. Not all participating brands offer all member benefits. <a href="https://onepass.com.au/partners?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_partners" target="_blank">Click here</a> for benefits and exclusions for each participating brand.</p>}
        </Container>
    </div>
}

const Plan = () => {
    const benefits = [
        {icon: "free_delivery", title: "Free delivery on eligible items or orders"}, 
        {icon: "flybuys", title: "5x Flybuys points at Kmart, Target, Bunnings Warehouse and Officeworks"}, 
        {icon: "365_day_returns", title:"365 day change of mind returns"},
        {icon: "express_click_collect", title:"Express Click & Collect at Kmart and Bunnings Warehouse"}, 
        {icon: "pulse-rewards", title:"Pulse Rewards tier members collect 2 Pulse Rewards points per $1 spent in-store at Priceline"}]
            
    const tiles = [
        {
            intro: "Annual",
            cost: <><span className='text-is2_5xl'>$40</span>/year after <br className="md:hidden"/>free trial†</>,
            trial: "30",
            trial_info: "",
            benefits: benefits,
            info:<>OnePass benefits include*</>,
            extra_title: "Annual plan benefits",
            extra: ["Get 12 months for the price of 10!"],
            btn_style: "!bg-op-purple",
            btn:"https://my.onepass.com.au/auth/signup?onramp=onepass_annual?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_signup",
            save:<>save $8 per year#</>,
            save_style: "bg-[#B0F4DE]",
            badge:"best value",
        },
        {
            intro: "Monthly",
            cost: <><span className='text-is2_5xl'>$4</span>/month after free trial†</>,
            trial: "30",
            trial_info:"",
            benefits: benefits,
            info:<>OnePass benefits include*</>,
            btn_style: "basic black font-medium",
            btn:"https://my.onepass.com.au/auth/signup?onramp=onepass_monthly?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_signup",
            save: <>equals $48 annually</>,
            save_style: "bg-[#EEEEE9]"
        }
    ]
    return <div className="py-16 bg-is-gray-20">
        <Container>
            <h2 className="text-center font-medium">Choose a plan that works <br className="md:hidden"/>for you</h2>
            <p className="text-center mb-0 text-is2-gray-700">Are you ready for more? Start your OnePass plan and get more of what you want, when you want it. With awesome value every step of the way.</p>
        
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 py-9 md:py-12 mx-auto">
                {tiles.map((el, i) => {
                    return <div key={i} className={cls("grid-col-1 relative flex flex-col h-full items-start justify-between rounded-2xl shadow-lg border bg-white py-8 px-6", el?.badge ? "border-2 border-[#666]" : "border-is-gray-85")}>

                        <div className="flex flex-col w-full">
                            <div className="pb-8 border-b border-is-gray-85 w-full">
                                <div className="flex items-center justify-between">
                                    <p className="mb-0 font-medium !text-is2_xl !leading-[32px]">{el.intro}</p>
                                    {el?.badge && <div className="bg-op-purple text-white px-2.5 py-1 rounded text-sm w-fit h-fit">{el.badge}</div>}
                                </div>
                                <h2 className="mt-8 mb-0 font-medium !text-is2_xl">{el.cost}</h2>
                                {el?.save && <div className={cls(el?.save_style, "px-2.5 py-1.5 mt-1 rounded text-sm text-[#3A006A] w-fit")}>{el.save}</div>}
                            </div>

                            <div className="py-6">
                                {el.extra && <div className="pb-6">
                                    <h3 className="my-0">{el.extra_title}</h3>
                                    <ul className="py-2">
                                        {el?.extra?.map((info, i) => {
                                            return  <li className="flex pb-4 items-start" key={i}><img src={`${op_img_path}/check-circle_icon.svg`} className="mr-4" alt="tick"/> {info}</li>
                                        })}
                                    </ul>
                                </div>}
                                
                                <h3 className="font-bold my-0">{el.info}</h3>
                                <ul className="pt-2">
                                    {el?.benefits.map((info, i) => {
                                        return  <li className="flex pb-4 items-start" key={i}><img className="w-7 h-auto mr-4" src={`${op_img_path}/${info.icon}.png`} alt="tick"/> {info.title}</li>
                                    })}
                                </ul>
                                {el?.learn_more && <a className="font-bold underline flex items-center gap-1 hover:text-op-purple text-sm" target="_blank" href={el.learn_more}>{el?.lm_text} <img className="h-4 w-4" src={`${op_img_path}/external-link.svg`} alt="external"/></a>}
                            </div>
                        </div>

                        <Button className={cls(el.btn_style, "!rounded-[8rem]")} fluid primary as='a' href={el.btn}>Start {el.trial} day free trial</Button>
                    </div>
                })}
            </div>

            <p className="text-sm text-is-gray-90">
                {pricing_terms} See <a href="#terms">T&Cs</a> for full details.
            </p>
        </Container>
    </div>
}

const Supercharge = () => {
    return <div className="text-center text-white" style={{background: 'linear-gradient(352deg, #9900F1 93.87%, #6911B3 151.58%)'}}>
            <Container>
                <div className="flex flex-wrap md:flex-nowrap justify-between w-fit mx-auto pt-10 text-center px-4 md:px-0">
                    <div className="w-full md:w-[328px] md:py-10 lg:mr-[104px]">
                        <h2 className="font-bold mb-1 !text-is2_2xl"><span className="text-[#B0F4DE]">SUPERCHARGE</span><br/><span className="text-white">YOUR SHOP<br/> FOR $4/MONTH</span></h2>
                        <p className="mb-6">Your membership to more from Australia's favourite brands.</p>
                        <Button as="a" href="https://my.onepass.com.au/auth/signup?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_signup" basic className="!text-base !py-4 !font-medium md:w-[244px] w-full">Start your free trial</Button>
                        <p className="mt-6">Try it free, cancel anytime.</p>
                    </div>
                    <div className="flex overflow-hidden justify-center relative w-[95%] md:w-[371px] h-[200px] md:h-auto pt-4 md:pt-0 mx-auto md:mx-0">
                        <img src={`${op_img_path}/price_icon.svg`} className="block md:hidden h-[106px] absolute left-4 bottom-4" alt="Become a member $4 a month"/>
                        <img src={`${op_img_path}/free_trial_bird.png`} className="md:w-[371px] h-auto mx-auto md:mx-0 absolute -right-12" alt="OnePass bird"/>
                    </div>
                </div>
            </Container>
    </div>
}

const Terms = ({usr, onepassDiscountStrings}) => {
  
    return <div className={cls("bg-is-gray-10 py-[52px] md:py-24")} id="terms">
        <Container>
            <h5>Terms & Conditions</h5>
            {!usr &&
                <p className="text-sm mb-6 text-is-gray-90">
                    {pricing_terms}
                </p>
            }
            <>
                <p className="text-sm mb-0 text-is-gray-90">
                    For full OnePass terms and conditions, please refer to the <a href="https://onepass.com.au?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_terms" target="_blank" className="text-is-blue">OnePass Website.</a><br/><br/>
                </p>
                <p className="text-sm font-bold text-black mb-4">InstantScripts and OnePass offer - terms and conditions</p>
                <ul className="text-sm list-disc list-inside text-is-gray-90">
                    {onepassDiscountStrings && onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS] && (<li>At InstantScripts you can enjoy {onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST]} off your first eligible InstantScripts service1 and {onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS]} off each eligible service thereafter. You will also enjoy free standard delivery on prescription medications in Australia*.</li>)}
                    <li>Free standard delivery applies to medication in Australia. Express delivery is not included in the offer.</li>
                    <li>Discount does not apply to the price of any medication, the Weight Management Program, Mental Health Care Plan Consultations or Mental Health Care Plan reviews.</li>
                    <li>InstantScripts reserves the right to suspend, vary, alter or amend all or any part of these Terms and Conditions and the Offer from time to time.</li>
                    <li>The offer is only available to individuals that hold a Australian Government Individual Healthcare Identifier and situated in Australia at the time the services are provided.</li>
                    <li>InstantScripts may send marketing material to its members, who they have permission to do so, to tell them about the affiliation and offers.</li>
                    <li>OnePass may send marketing material to its members, who they have permission to do so, to tell them about the affiliation and offers.</li>
                    <li>The offer cannot be used in conjunction with any other discount offer.</li>
					<li>Delivery is available for prescription medicines obtained through the online prescriptions service and treatment plans only.</li>
                </ul>
                     
            </>
        </Container>
    </div>
}

const OnePass = () => {

    const user_in = app?.user?.prof?.onepass
    
    const cust_supp = <>Contact our customer support team via the chat icon on our website or contact <a href="mailto:support@instantscripts.com.au">support@instantscripts.com.au</a>.</>
    const onepassDiscountStrings = useOnePassDiscountStrings(); 
    
    const faq = onepassDiscountStrings ?
    [
        {
            title: 'What are the benefits of joining InstantScripts with OnePass?',
            content: <>OnePass members, including members who are on a free trial, are eligible for the following benefits at InstantScripts:
            <li>Free standard delivery<sup>#</sup> on prescription medication in Australia prescribed by an InstantScripts doctor</li>
            {onepassDiscountStrings && onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS] && (<li>{onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS]} discount on Eligible InstantScripts Services*{onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST] && ` and ${onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST]} off your first order`}</li>)}<br/>
            <sup>#</sup>Standard delivery only, express delivery not eligible for free delivery.<br/><br/>
            *Eligible InstantScripts Services is limited to Online Prescription Consultations, Medical Certificates, Doctor Consultations, Blood Test Requests, Specialist Referrals.<br/><br/>
            To see full terms and conditions of the benefits <a href="#terms">click here</a>.</>
        },
        {
            title: 'How can I access the InstantScripts and OnePass Offer?',
            content: 'You will need to have an active OnePass membership or be currently on a free trial and link your OnePass and InstantScripts accounts in order to access your OnePass InstantScripts benefits. You can then login either via OnePass or InstantScripts.'
        },
        {
            title: 'Once I’ve signed up to a OnePass membership, how long does it take before I can access the Offer?',
            content: 'Benefits will be available at InstantScripts immediately upon linking your OnePass and InstantScripts account.'
        },
        {
            title: 'I cannot access my InstantScripts account using my OnePass email address and password. What should I do?',
            content: cust_supp
        },
        {
            title: 'My InstantScripts account failed to link to my OnePass from the OnePass website. What should I do?',
            content: <>Contact OnePass customer support team via 1300 026 710, or <a href="https://support.onepass.com.au/s/customer-support?utm_source=instantscripts&utm_medium=referral-web&utm_campaign=op-landingpage_support">visit</a> the OnePass contact us page for other contact options.</>
        },
        {
            title: 'Where can I get help?',
            content: cust_supp
        },
        {
            title: 'I was charged a fee for delivery on an item that was eligible for free delivery. What should I do?',
            content: cust_supp
        },
        {
            title: 'What locations does free delivery cover?',
            content: <>Prescription medications can be delivered Australia wide via the Australia Post network. If you are being charged a fee for delivery and believe you should have received free delivery contact <a href="mailto:support@instantscripts.com.au">support@instantscripts.com.au.</a></>
        },
        {
            title: `What products are eligible for the ${onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS]} discount?`,
            content: `Products eligible for the ${onepassDiscountStrings[PUBLIC_DISCOUNT_KEYS.ONE_PASS]} discount are limited to Online Prescription Consultations, Medical Certificates, Doctor Consultations, Blood Test Requests and Specialist Referrals. The discount does not apply to the price of prescription medicines, the Weight Management Program, Mental Health Care Plan Consultations or Mental Health Care Plan reviews.`
        },
        {
            title: 'The discount was not applied to services that are eligible to receive the discount. What should I do?',
            content: cust_supp
        },
        {
            title: 'How is my personal information collected and shared?',
            content: <>OnePass and InstantScripts take your privacy seriously. When you link your InstantScripts and OnePass accounts, InstantScripts and OnePass will
            confirm you have an account with the other to enable your accounts to be linked and to enable you
            to receive your benefits and communications (e.g. free delivery and discounts). We don’t share the type or details of any doctor consultations, medical certificates, test results, referrals or script history.<br/><br/>
            Your personal information will be collected and handled in accordance with the InstantScripts <Link to="/privacy">Privacy Policy</Link>.</>
        }
    ] : []

	return(
        <>
          <SEOHeaders
            title="OnePass | InstantScripts"
            path={'/onepass'}
            index={true}
            follow={true}
        />
          <div className='one-pass bg-white'>
            
            <Hero usr={user_in}/>

            <Intro usr={user_in} onepassDiscountStrings={onepassDiscountStrings}/>
	        
            {user_in && <Benefits/> }

            {!user_in && <>
                <Other usr={user_in}/>
                <Plan />
            </>}

            <FAQ headerAs='h2' data={faq} hide_warn readmore={false} clsn={user_in ? "bg-white" : "bg-is-gray-20 md:bg-is-gray-10"} faq_cls="bg-white"/>

            {user_in && <Other usr={user_in}/>}

            {!user_in && <Supercharge /> }

            <Terms usr={user_in} onepassDiscountStrings={onepassDiscountStrings}/>
	  
	        </div>
        </>
      
    )  
  
};

export default OnePass;
